import { Box, Checkbox, Typography } from "@mui/material";
import { ReactComponent as UnCheckedIcon } from "../../../../../stack/environment/icons/checkbox-off.svg";
import { ReactComponent as CheckedIcon } from "../../../../../stack/environment/icons/checkbox-on.svg";
import PlaybookButton from "./PlaybookButton";
import RemediationCollapseSection from "./RemediationCollapseSection";

const RemediationSteps = ({ fullControl }) => {
  return (
    <RemediationCollapseSection
      title="How should I fix it?"
      defaultCollapsed={false}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" flexDirection="column" gap={1}>
          {fullControl?.remediation.remediation_steps_summary?.map(
            (step, index) => (
              <Box
                key={index}
                display="flex"
                flexDirection="row"
                alignItems="flex-start"
                gap={1}
              >
                <Checkbox
                  icon={<UnCheckedIcon />}
                  checkedIcon={<CheckedIcon />}
                  disableRipple
                />
                <Typography variant="body2" paddingTop={1}>
                  {step}
                </Typography>
              </Box>
            )
          )}
        </Box>
        <PlaybookButton
          control={fullControl}
          sx={{ height: "30px", padding: "0 6px" }}
          outline={true}
        />
      </Box>
    </RemediationCollapseSection>
  );
};

export default RemediationSteps;
